module.exports = {"el-upload-secondary":{"event":"change","prop":"fileList"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/public/models.json
// module id = qGj0
// module chunks = 208